module.exports = __webpack_public_path__ + "static/img/drew-30plus.5382082.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drew-30plus.gif
// module id = 9d8B
// module chunks = 1